module.exports = __webpack_public_path__ + "html/email-sending.component.html";